const RechargeAddress = {
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  company: 'company',
  country: 'country',
  country_code: 'country_code',
  created_at: 'created_at',
  customer_id: 'customer_id',
  discounts: 'discounts',
  first_name: 'first_name',
  id: 'id',
  include: 'include',
  is_gift: 'is_gift',
  last_name: 'last_name',
  note_attributes: 'note_attributes',
  order_attributes: 'order_attributes',
  order_note: 'order_note',
  payment_method_id: 'payment_method_id',
  phone: 'phone',
  presentment_currency: 'presentment_currency',
  province: 'province',
  shipping_lines_override: 'shipping_lines_override',
  updated_at: 'updated_at',
  zip: 'zip'
};

export { RechargeAddress };
